import React from 'react';

export const CrossIcon = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id="crossIconT">cross icon</title>
            <desc id="crossIconD">A vector illustration of a cross icon</desc>
            <path
                d="M11.4164 0.583417L0.583051 11.4167M0.583008 0.583374L11.4164 11.4167"
                stroke="url(#paint0_linear_120_4459)"
                strokeLinecap="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_120_4459"
                    x1="5.9997"
                    y1="0.583374"
                    x2="5.9997"
                    y2="11.4167"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8F29FD" />
                    <stop offset="1" stopColor="#126BE4" />
                </linearGradient>
            </defs>
        </svg>
    );
};
